export const unit = {
  'Are you sure you want to continue?':
    '¿Estás seguro de que querés continuar?',
  Attention: 'Atención',
  Cancel: 'Cancelar',
  Continue: 'Continuar',
  'If you proceed, those areas will be removed from the schedule':
    'Si continuás, esas áreas serán removidas de la agenda.',
  'I understand, continue': 'Entiendo, continuar',
  "Let's schedule?": '¿Agendamos?',
  'New clinic': 'Nueva clínica',
  'Other clinic': 'Otra clínica',
  'Schedule at your last clinic or choose another one of your preference':
    'Agendá en tu última clínica o elegí otra de tu preferencia.',
  Reschedule: 'Reagendar',
  'Select areas': 'Seleccionar áreas',
  'Select schedule': 'Seleccionar horario',
  'Select unit': 'Seleccionar unidad',
  'The areas above are exclusive to another unit, and cannot be scheduled at {{unit}}':
    'Las áreas de arriba son exclusivas de otra unidad y no pueden ser agendadas en {{unit}}.',
};
